var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Grid, Select, Table } from 'semantic-ui-react';
import { CustomPriceRow } from "../../admin/CustomPriceRow";
import FieldWithErrorDisplay from "../../FieldWithErrorDisplay";
import { Help } from "../../Help";
import { LiquidVolume } from "../automated-pro/RnaCatalog";
import { priceColumn } from "../rna-fish/EditKitForm";
import { ComponentPriceDisplay } from "../rna-fish/ProbeSetForm";
var BufferForm = /** @class */ (function (_super) {
    __extends(BufferForm, _super);
    function BufferForm(props) {
        var _this = _super.call(this, props) || this;
        _this.proBuffersHelp = React.createElement(React.Fragment, null,
            React.createElement(Help, null,
                "For the following sample types, 10 experiments require approximately:",
                React.createElement("p", null),
                React.createElement(Table, { celled: true, striped: true },
                    React.createElement(Table.Header, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.HeaderCell, null, "Sample type"),
                            React.createElement(Table.HeaderCell, null, "HCR\u2122 HiFi Probe Hybridization Buffer (mL)"),
                            React.createElement(Table.HeaderCell, null, "HCR\u2122 HiFi Probe Wash Buffer (mL)"),
                            React.createElement(Table.HeaderCell, null, "HCR\u2122 Pro Amplifier Wash Buffer (mL)"))),
                    React.createElement(Table.Body, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Sample on a slide (e.g., tissue section or adherent cells)"),
                            React.createElement(Table.Cell, null, "3"),
                            React.createElement(Table.Cell, null, "400"),
                            React.createElement(Table.Cell, null, "850")),
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Sample in solution (e.g., whole-mount embryo or cells in suspension)"),
                            React.createElement(Table.Cell, null, "4"),
                            React.createElement(Table.Cell, null, "20"),
                            React.createElement(Table.Cell, null, "80")))),
                React.createElement("p", null),
                "Note: HCR\u2122 HiFi Probe Wash Buffer and HCR\u2122 Pro Amplifier Wash Buffer are provided at 4x and 10x respectively; dilute to 1x using UltraPure H\u2082O prior to use. Hence, purchasing 50 mL of HCR\u2122 HiFi Probe Wash Buffer (provided at 4x) yields 200 mL of 1x HCR\u2122 HiFi Probe Wash Buffer (sufficient for approximately 100 experiments for a sample in solution using the table above)."));
        _this.volumeOptions = function (b) {
            return b.volumeMls.map(function (v) {
                return {
                    text: v.valueMl > 0 ? v.valueWithUnit : 'None',
                    value: v.valueMl
                };
            });
        };
        _this.onWashChange = function (_, data) {
            var scales = _this.props.catalog.goldWash.volumeMls;
            _this.onVolumeChange({
                volumeMls: scales,
                defaultVolumeMl: scales[0],
            }, data, 'probeWash');
        };
        _this.onHybridizationChange = function (_, data) {
            var scales = _this.props.catalog.hybridization.volumeMls;
            _this.onVolumeChange({
                volumeMls: scales,
                defaultVolumeMl: scales[0]
            }, data, 'hybridization');
        };
        _this.onProAmpWashChange = function (_, data) {
            var scales = _this.props.catalog.proAmpWash.volumeMls;
            _this.onVolumeChange({
                volumeMls: scales,
                defaultVolumeMl: scales[0]
            }, data, 'ampWash');
        };
        _this.onVolumeChange = function (b, data, field) {
            var val = b.volumeMls.find(function (v) { return v.valueMl === data.value; });
            var newScale = val;
            if (newScale === undefined) {
                if (!_this.props.enableCustomScale) {
                    throw new RangeError("Could not find volume " + data.value);
                }
                if (typeof data.value !== 'string') {
                    throw new Error("Invalid scale " + data.value);
                }
                var num = parseInt(data.value, 10);
                if (num === undefined || isNaN(num)) {
                    throw new Error("Invalid scale " + val);
                }
                newScale = new LiquidVolume(num);
            }
            var update = {};
            update[field] = newScale;
            _this.props.onBufferChange(update, _this.props.onUserSelection);
        };
        _this.onCustomPriceChange = function (newStateFn, callback) {
            _this.props.onBufferChange(function (oldState) {
                return {
                    customPrice: newStateFn(oldState.customPrice)
                };
            }, callback);
        };
        return _this;
    }
    BufferForm.prototype.render = function () {
        return React.createElement(Grid, { columns: 4, stackable: true },
            React.createElement(React.Fragment, null,
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { showErrors: this.props.showErrors, errorPath: '/buffersComponent/hybridizationBufferMl', errors: this.props.errors, labelContent: React.createElement(React.Fragment, null,
                                "HiFi Probe Hybridization Buffer\u00A0",
                                this.proBuffersHelp), labelFor: 'buffer-probe-hybridization' },
                            React.createElement(Select, { name: 'buffer-probe-hybridization', onChange: this.onHybridizationChange, allowAdditions: this.props.enableCustomScale, search: this.props.enableCustomScale, options: this.volumeOptions(this.props.catalog.hybridization), value: this.props.bufferState.hybridization.valueMl }))),
                    this.props.sampleType.id !== "NORTHERN_BLOT" && React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { showErrors: this.props.showErrors, errorPath: '/buffersComponent/goldWashBufferMl', errors: this.props.errors, labelContent: React.createElement(React.Fragment, null,
                                "HiFi Probe Wash Buffer\u00A0",
                                this.proBuffersHelp), labelFor: 'buffer-probe-gold-wash' },
                            React.createElement(Select, { name: 'buffer-probe-gold-wash', onChange: this.onWashChange, allowAdditions: this.props.enableCustomScale, search: this.props.enableCustomScale, options: this.volumeOptions(this.props.catalog.goldWash), value: this.props.bufferState.probeWash.valueMl })))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { showErrors: this.props.showErrors, errorPath: '/buffersComponent/proAmpWashBufferMl', errors: this.props.errors, labelContent: React.createElement(React.Fragment, null,
                                "Pro Amplifier Wash Buffer\u00A0",
                                this.proBuffersHelp), labelFor: 'pro-amplification' },
                            React.createElement(Select, { name: 'pro-amplification-wash', onChange: this.onProAmpWashChange, allowAdditions: this.props.enableCustomScale, search: this.props.enableCustomScale, options: this.volumeOptions(this.props.catalog.proAmpWash), value: this.props.bufferState.ampWash.valueMl }))),
                    React.createElement(Grid.Column, null),
                    React.createElement(Grid.Column, { only: "tablet computer" }),
                    priceColumn(React.createElement(ComponentPriceDisplay, { loading: this.props.priceLoading, effectivePriceCents: this.props.effectivePriceCents, listPriceCents: this.props.listPriceCents }), this.props.effectivePriceCents !== this.props.listPriceCents))),
            this.props.enableCustomPrice &&
                React.createElement(CustomPriceRow, { customPrice: this.props.bufferState.customPrice, defaultEffectivePriceCents: this.props.effectivePriceCents, errors: this.props.errors, errorPathPrefix: '/buffersComponent', onPriceChange: this.onCustomPriceChange, onUserInput: this.props.onUserSelection }));
    };
    return BufferForm;
}(React.PureComponent));
export default BufferForm;
//# sourceMappingURL=BufferForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/manual-pro/BufferForm.js
// module id = 594
// module chunks = 0